// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Track page views
export const trackPageView = (pageTitle: string, pagePath: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-4WN8BXVGLE', {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: pagePath,
    });
  }
};

// Track custom events
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user engagement events
export const trackUserEngagement = (action: string, details?: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: 'user_engagement',
      ...details,
    });
  }
};

// Track trading-related events
export const trackTradingEvent = (
  action: string,
  symbol?: string,
  quantity?: number,
  price?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: 'trading',
      event_label: symbol,
      value: quantity,
      custom_parameter_price: price,
    });
  }
};

// Track rule evaluation events
export const trackRuleEvent = (
  action: string,
  ruleName?: string,
  ruleType?: string,
  triggered?: boolean
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: 'rule_evaluation',
      event_label: ruleName,
      custom_parameter_rule_type: ruleType,
      custom_parameter_triggered: triggered,
    });
  }
};

// Track error events
export const trackError = (errorType: string, errorMessage: string, errorStack?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'exception', {
      description: errorMessage,
      fatal: false,
      custom_parameter_error_type: errorType,
      custom_parameter_error_stack: errorStack,
    });
  }
};

// Initialize analytics (called on app startup)
export const initializeAnalytics = () => {
  if (typeof window !== 'undefined') {
    // Track app initialization
    trackEvent('app_initialized', 'application', 'MarketEye Trade Desk');
    
    // Track initial page view
    trackPageView('MarketEye - Trade Desk', window.location.pathname);
  }
}; 